<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <!-- Nevigater -->
        <v-layout mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.push('/post-approve')"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="viewData"
          >
            <span>ดูข้อมูล</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3E7662;font-weight: bold;font-size: 24px;"
          >
            <span>รายงานสรุปผลการวิจัย</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: left;font-weight: bold;font-size: 28px;color: white"
                @click="setData"
              >
                <div>แบบรายงานสรุปผลการวิจัย</div>
                <div style="font-size: 18px;">Final Report</div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RF 06_2563</span>
              </v-flex>
            </v-layout>

            <!-- blog 1 -->
            <v-card class="mb-12 px-12">
              <v-layout py-12>
                <v-flex>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อโครงการวิจัย</span>
                    </v-flex>
                    <v-flex xs6>
                      <textarea-form
                        :model="form.researchName"
                        style="font-weight: bold"
                        @update-data="updateData('researchName', $event)"
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>รหัสโครงการวิจัย</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.researchCode"
                        style="font-weight: bold"
                        @update-data="updateData('researchCode', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ผู้สนับสนุนทุนวิจัย</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.researchInvestor"
                        style="font-weight: bold"
                        @update-data="updateData('researchInvestor', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ผู้วิจัยหลัก</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.mainResearcher"
                        style="font-weight: bold"
                        @update-data="updateData('mainResearcher', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>โทรศัพท์</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.phoneNumber"
                        style="font-weight: bold"
                        @update-data="updateData('phoneNumber', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>อีเมล</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.email"
                        style="font-weight: bold"
                        @update-data="updateData('email', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- blog 2 -->
            <v-layout
              pt-12
              pb-8
              mb-12
              style="background-color: white;padding-left: 100px;padding-right: 100px;"
            >
              <v-flex>
                <!-- row 1 -->
                <v-layout>
                  <v-flex
                    xs3
                    pt-2
                    mr-3
                    style="text-align: right;font-weight: bold;"
                  >
                    <span>วันที่รับรองโครงร่างการวิจัยครั้งแรก</span>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      :model="firstDate"
                      style="font-weight: bold"
                      @update-data="updateDate('firstDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                  <v-flex
                    xs3
                    pt-2
                    mr-3
                    style="text-align: right;font-weight: bold;"
                  >
                    <span>วันที่รับรองโครงร่างการวิจัยครั้งล่าสุด</span>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      :model="lastDate"
                      style="font-weight: bold"
                      @update-data="updateDate('lastDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                </v-layout>

                <!-- row 2 -->
                <v-layout>
                  <v-flex
                    xs3
                    pt-2
                    mr-3
                    style="text-align: right;font-weight: bold;"
                  >
                    <span>วันที่เริ่มดำเนินการวิจัย</span>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      :model="startDate"
                      style="font-weight: bold"
                      @update-data="updateDate('startDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                  <v-flex
                    xs3
                    pt-2
                    mr-3
                    style="text-align: right;font-weight: bold;"
                  >
                    <span>วันที่สิ้นสุดการวิจัย</span>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      :model="endDate"
                      style="font-weight: bold"
                      @update-data="updateDate('endDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- blog 3 -->

            <v-layout
              pt-12
              pb-8
              mb-12
              style="background-color: white;padding-left: 100px;padding-right: 100px;"
            >
              <v-flex>
                <!-- Group 1 -->
                <v-layout pt-4>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;"
                      >Summary of Protocol Participants</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout py-6 pl-12>
                  <v-flex>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Accrual ceiling set by IEC/IRB</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.accrualCeiling"
                              style="font-weight: bold"
                              @update-data="
                                updateData('accrualCeiling', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total accrued participants</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalParticipants"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalParticipants', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants fail screening</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalScreening"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalScreening', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants withdrawn</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalWithdrawn"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalWithdrawn', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants dead</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalDead"
                              style="font-weight: bold"
                              @update-data="updateData('totalDead', $event)"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1 mb-4>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants complete the research</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalCompleteResearch"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalCompleteResearch', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- Group 2 -->
                <v-layout pt-8>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;"
                      >Summary of Protocol Participants</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout pt-6 pb-12 pl-12>
                  <v-flex>
                    <v-layout pt-1>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants experience adverse
                              events</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalExpAdversEvents"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalExpAdversEvents', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-1>
                      <v-flex d-flex justify-start>
                        <v-layout>
                          <v-flex class="d-flex align-center xs6">
                            <span style="color: #3E7662;"
                              >Total participants experience SUSARs</span
                            >
                          </v-flex>
                          <v-flex class="xs3">
                            <textfield-form
                              type="number"
                              hide-detail
                              :model="form.totalExpSUSARs"
                              style="font-weight: bold"
                              @update-data="
                                updateData('totalExpSUSARs', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- Group 3 -->
                <v-layout py-6>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;">
                      Has there been any protocol deviation/violation or
                      compliance issues occurred during the study?
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12>
                  <v-flex style="color: #3E7662">
                    <v-radio-group v-model="form.hasIssue" row id="hasIssue">
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="No"
                        value="0"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="YES (please attach a report)"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <!-- Group 4 -->
                <v-layout py-6>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;">
                      Has there been any complaint or warning letter against the
                      research or investigator during the study?
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12>
                  <v-flex style="color: #3E7662">
                    <v-radio-group
                      v-model="form.hasWarning"
                      row
                      id="hasWarning"
                    >
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="No"
                        value="0"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="YES (please attach a report)"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <!-- Group 5 -->
                <v-layout py-6>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;">
                      Are there any benefit or negative impact to participants
                      after the study completion?
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12 pb-12>
                  <v-flex style="color: #3E7662">
                    <v-radio-group v-model="form.hasImpact" row id="hasImpact">
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="No"
                        value="0"
                      ></v-radio>
                      <v-radio color="#3E7662" label="YES" value="1"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- blog 4 -->
            <v-layout
              pt-12
              pb-8
              mb-12
              style="background-color: white;padding-left: 100px;padding-right: 100px;"
            >
              <v-flex>
                <!-- row 1 -->
                <v-layout pb-4>
                  <v-flex d-flex justify-start>
                    <span style="font-weight: bold;font-size: 18px;">
                      Summary of Result (or attached abstract)
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout pt-6>
                  <v-flex d-flex justify-start>
                    <textarea-form
                      :rows="15"
                      :model="form.summaryOfResult"
                      @update-data="updateData('summaryOfResult', $event)"
                    ></textarea-form>
                  </v-flex>
                </v-layout>
                <v-layout mb-12>
                  <v-flex d-flex justify-start>
                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                  </v-flex>
                  <v-flex d-flex justify-end>
                    <span>หน้า 1 จาก 1 หน้า</span>
                  </v-flex>
                </v-layout>
                <!-- row 2 -->
                <v-layout pt-12 pb-4>
                  <v-flex xs6 pl-3 mr-6>
                    <v-text-field
                      dense
                      placeholder="signature"
                      append-icon="edit"
                      color="#3E7662"
                      v-model="form.signature"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      style="font-weight: bold"
                      label="Date"
                      :model="reportDate"
                      @update-data="updateDate('reportDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="viewData"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <v-icon class="mr-3">add</v-icon>
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      researchName: "",
      researchCode: "",
      researchInvestor: "",
      mainResearcher: "",
      phoneNumber: "",
      email: "",
      firstDate: new Date().toISOString().substr(0, 10),
      lastDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      hasIssue: "",
      hasWarning: "",
      hasImpact: "",
      summaryOfResult: "",

      accrualCeiling: "",
      totalParticipants: "",
      totalScreening: "",
      totalWithdrawn: "",
      totalDead: "",
      totalCompleteResearch: "",
      totalExpAdversEvents: "",
      totalExpSUSARs: "",
      signature: "",
      reportDate: new Date().toISOString().substr(0, 10),
    },
    userID: "",
    firstDate: "",
    lastDate: "",
    startDate: "",
    endDate: "",
    reportDate: "",
  }),
  computed: {
    computed: {
      ...mapState({
        user: (state) => state.Auth.user,
      }),
    },
  },
  created() {
    // Check Permission Access
    //   if (this.user.currentRole !== 3) {
    //     this.$router.go(-1);
    //  }

    this.userID = this.$route.query.userID;
    this.getRF06();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "firstDate") {
        this.form.firstDate = val.date;
        this.firstDate = this.changeDate(val.date);
      }
      if (name === "lastDate") {
        this.form.lastDate = val.date;
        this.lastDate = this.changeDate(val.date);
      }
      if (name === "startDate") {
        this.form.startDate = val.date;
        this.startDate = this.changeDate(val.date);
      }
      if (name === "endDate") {
        this.form.endDate = val.date;
        this.endDate = this.changeDate(val.date);
      }
      if (name === "reportDate") {
        this.form.reportDate = val.date;
        this.reportDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    viewData() {
      this.$router.push({
        name: "ViewDataPostApprove",
        query: { id: this.userID },
      });
    },
    getRF06() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF06", this.$route.query.id)
        .then((res) => {
          this.form.researchName = res.researchName;
          this.form.researchCode = res.researchCode;
          this.form.researchInvestor = res.researchInvestor;
          this.form.mainResearcher = res.mainResearcher;
          this.form.phoneNumber = res.phoneNumber;
          this.form.email = res.email;
          this.form.firstDate = res.firstDate;
          this.firstDate = this.changeDate(res.firstDate);
          this.form.lastDate = res.lastDate;
          this.lastDate = this.changeDate(res.lastDate);
          this.form.startDate = res.startDate;
          this.startDate = this.changeDate(res.startDate);
          this.form.endDate = res.endDate;
          this.endDate = this.changeDate(res.endDate);
          this.form.hasIssue = res.hasIssue.toString();
          this.form.hasWarning = res.hasWarning;
          this.form.hasImpact = res.hasImpact.toString();
          this.form.summaryOfResult = res.summaryOfResult;
          this.form.signature = res.signature.toString();
          this.form.reportDate = res.reportDate;
          this.reportDate = this.changeDate(res.reportDate);

          this.form.accrualCeiling = res.accrualCeiling
            ? res.accrualCeiling
            : "";
          this.form.totalParticipants = res.totalParticipants
            ? res.totalParticipants
            : "";
          this.form.totalScreening = res.totalScreening
            ? res.totalScreening
            : "";
          this.form.totalWithdrawn = res.totalWithdrawn
            ? res.totalWithdrawn
            : "";
          this.form.totalDead = res.totalDead ? res.totalDead : "";
          this.form.totalCompleteResearch = res.totalCompleteResearch
            ? res.totalCompleteResearch
            : "";
          this.form.totalExpAdversEvents = res.totalExpAdversEvents
            ? res.totalExpAdversEvents
            : "";
          this.form.totalExpSUSARs = res.totalExpSUSARs
            ? res.totalExpSUSARs
            : "";

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.$store
            .dispatch("FormRF/saveRF06", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              this.viewData();
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //   title: "Save failed!",
              //   text: "บันทึกไม่สำเร็จ",
              //   icon: "warning",
              // });
              // this.isLoading = false;
            });
        }
      });
    },
    setData() {
      this.form.researchName = "โครงการทดสอบ";
      this.form.researchCode = "RF001";
      this.form.researchInvestor = "ทดสอบ ผู้สนับสนุนทุนวิจัย";
      this.form.mainResearcher = "ทดสอบ ผู้วิจัยหลัก";
      this.form.phoneNumber = "0852121014 ";
      this.form.email = "test@mail.com ";
      (this.form.firstDate = new Date().toISOString().substr(0, 10)),
        (this.form.lastDate = new Date().toISOString().substr(0, 10)),
        (this.form.startDate = new Date().toISOString().substr(0, 10)),
        (this.form.endDate = new Date().toISOString().substr(0, 10)),
        (this.form.hasIssue = "0");
      this.form.hasWarning = "0";
      this.form.hasImpact = "0";
      this.form.summaryOfResult = "ทดสอบ Summary of Result";
      this.form.signature = "นายทดสอบ";
      this.form.reportDate = new Date().toISOString().substr(0, 10);
    },
  },
};
</script>

<style scoped></style>
